/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionwriteortranslate4Inputs */

const en_eventdescriptionwriteortranslate4 = /** @type {(inputs: Eventdescriptionwriteortranslate4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write it yourself for free, or have it translated.`)
};

const de_eventdescriptionwriteortranslate4 = /** @type {(inputs: Eventdescriptionwriteortranslate4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreib den Text selbst, das ist kostenlos, oder lass ihn übersetzen.`)
};

/**
* | output |
* | --- |
* | "Write it yourself for free, or have it translated." |
*
* @param {Eventdescriptionwriteortranslate4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionwriteortranslate4 = /** @type {((inputs?: Eventdescriptionwriteortranslate4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionwriteortranslate4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionwriteortranslate4(inputs)
	return de_eventdescriptionwriteortranslate4(inputs)
});
export { eventdescriptionwriteortranslate4 as "eventDescriptionWriteOrTranslate" }